import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ordFilter'
})
export class OrdFilterPipe implements PipeTransform {
  transform(items, searchText: any): any[] {
    if (!items) {
      return [];
    }
    if (!searchText) {
      return items;
    }
    searchText = searchText.toLowerCase();
    if (items) { }
    return items.filter(it => {
      return (

        it.data.ord.toLowerCase().includes(searchText) ||
        it.data.doktor.toLowerCase().includes(searchText)
      );
    });
  }
}
